import { render, staticRenderFns } from "./SurveyTab.vue?vue&type=template&id=b939997e&scoped=true&"
import script from "./SurveyTab.vue?vue&type=script&lang=js&"
export * from "./SurveyTab.vue?vue&type=script&lang=js&"
import style0 from "./SurveyTab.vue?vue&type=style&index=0&id=b939997e&lang=scss&scoped=true&"
import style1 from "./SurveyTab.vue?vue&type=style&index=1&id=b939997e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b939997e",
  null
  
)

export default component.exports